<template>
  <div
    class="email-recipient-nav"
  >
    <router-link
      class="btn btn-block btn-primary"
      tag="button"
      :to="{
        name: 'create_email_recipient',
        params: {
          emailId: emailId,
          newsletterId: newsletterId
        }
      }"
      v-if="emailId"
    >
      Add Recipient
    </router-link>
    <button
      class="btn btn-block btn-danger"
      v-on:click="deleteByStatus('queued')"
    >
      Delete Queued Recipients
    </button>
  </div>
</template>
<script>
import EmailMixin from '@/mixins/EmailMixin'

import FlashStore from '@/stores/FlashStore'

export default {
  mixins: [
    EmailMixin
  ],

  methods: {
    deleteByStatus (status) {
      if (confirm(`Are you sure you want to delete all ${status} email recipients? This action cannot be undone!`)) {
        let emailType = this.newsletterId ? 'deleteNewsletterRecipientsByStatus' : 'deleteRecipientsByStatus'
        return this.$store.dispatch(
          `EmailModule/${emailType}`, {
            emailId: this.emailId,
            newsletterId: this.newsletterId,
            status: status
          }
        ).then(() => {
          this.$parent.$emit('requestPage')
          FlashStore.result('Recipients have been deleted.')
        }).catch(this.$root.processErrors)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailRecipientsActions.vue